

module.exports = __webpack_require__.stylable.create(
    "Body3524907301",
    {"classes":{"root":"Body3524907301__root","notificationBanner":"Body3524907301__notificationBanner","columnWrapper":"Body3524907301__columnWrapper"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    8,
    "Body3524907301",
    null
);
